import {createAction, handleActions} from 'redux-actions';
import {Api} from "../../api/api";
import {fetchSubmitForm, fetchSubmitFormFailed, resetSubmitFormData, fetchSubmitFormSuccess} from '../common/submitForm';
import {logout, onForbidden} from '../account/login';
import _ from 'lodash';
import {hideModal} from "../common/activeModal";
import moment from 'moment';
import { getContinentByCountry, getCountriesData } from '../common/location';

//- Actions
export const fetchGetCommissionsFailed = createAction('FETCH_GET_COMMISSIONS_FAILED');
export const fetchGetCommissionSuccess = createAction('FETCH_GET_COMMISSIONS_SUCCESS');
export const onGetCommissionsSuccess = (data) => (dispatch, getState) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0) {
        data.content = _.map(data.content, (elem) => {
            let baData = elem.businessAmbassador;
            let contractData = elem.businessAmbassadorContract;
            return {
                id: contractData.id,
                baId: baData.id,
                firstName: baData.firstName,
                lastName: baData.lastName,
                continent: getContinentByCountry(contractData.countryCodes[0], getState()),
                countryCodes: contractData.countryCodes,
                commissionPercent: contractData.commissionPercent,
                dateFrom: contractData.dateFrom,
                dateTo: contractData.dateTo
            };
        });
        dispatch(fetchGetCommissionSuccess(data));
    } else {
        dispatch(fetchGetCommissions(currentPage - 1));
    }
};
export const onFetchGetCommissions = createAction(
    'FETCH_GET_COMMISSIONS',
    (page, filters) => Api.getCommissions(page, filters),
    () => ({
        apiCall: true,
        onSuccess: onGetCommissionsSuccess,
        onFail: fetchGetCommissionsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetCommissions = (page) => (dispatch, getState) => {
    let BAFilter = getCommissionsBAFilter(getState());
    let countryFilter = getCommissionsCountryFilter(getState());
    let filters = {
        baId: BAFilter,
        countries: countryFilter || getCountriesData(getState()),
    }
    dispatch(onFetchGetCommissions(page, filters))
}

export const onGetCommissionsForCurrentPage = () => (dispatch, getState) => {
    let currentPage = getCurrentPageForCommissions(getState());
    dispatch(fetchGetCommissions(currentPage));
};

export const fetchAddCommission = (baId, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onAddCommission(baId, data));
};

export const onAddCommission = createAction(
    'FETCH_ADD_COMMISSION',
    (baId, data) => Api.addCommission(baId, data),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onRemoveCommissionSuccess = () => dispatch => {
    dispatch(resetSubmitFormData());
    dispatch(hideModal());
    dispatch(onGetCommissionsForCurrentPage());
};
export const onRemoveCommission = createAction(
    'FETCH_REMOVE_COMMISSION',
    (baId, commissionId) => Api.removeCommission(baId, commissionId),
    () => ({
        apiCall: true,
        onSuccess: onRemoveCommissionSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const removeCommission = () => (dispatch, getState) => {
    dispatch(fetchSubmitForm());
    let data = getCommissionToRemove(getState());
    dispatch(onRemoveCommission(data.baId, data.id));
};

export const setCommissionToRemove = createAction('COMMISSION_TO_REMOVE_SET', commissionId => commissionId);

export const fetchGetBAsListFailed = createAction('FETCH_GET_BA_S_LIST_FAILED');
export const fetchGetBAsListSuccess = createAction('FETCH_GET_BA_S_LIST_SUCCESS');
export const onFetchGetBAsListSuccess = (data) => (dispatch) => {
    let BAsList = _.map(data, (elem) => {
        return {
            id: elem.id,
            firstName: elem.firstName,
            lastName: elem.lastName
        }
    });
    dispatch(fetchGetBAsListSuccess(BAsList));
}
export const fetchGetBAsList = createAction(
    'FETCH_GET_BA_S_LIST',
    () => Api.getBusinessAmbassadors(),
    () => ({
        apiCall: true,
        onSuccess: onFetchGetBAsListSuccess,
        onFail: fetchGetBAsListFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetCommissionDataFailed = createAction('FETCH_GET_COMMISSION_DATA_FAILED');
export const fetchGetCommissionDataSuccess = createAction('FETCH_GET_COMMISSION_DATA_SUCCESS');
export const onFetchGetCommissionDataSuccess = (data) => (dispatch, getState) => {
    data["continent"] = getContinentByCountry(data.countryCodes[0], getState());
    dispatch(fetchGetCommissionDataSuccess(data));
}
export const fetchGetCommissionData = createAction(
    'FETCH_GET_COMMISSION_DATA',
    (baId, commissionId) => Api.getCommissionData(baId, commissionId),
    () => ({
        apiCall: true,
        onSuccess: onFetchGetCommissionDataSuccess,
        onFail: fetchGetCommissionDataFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchUpdateCommissionSuccess = (data) => (dispatch, getState) => {
    data["continent"] = getContinentByCountry(data.countryCodes[0], getState());
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetCommissionDataSuccess(data));
};
export const fetchUpdateCommission = (baId, commissionId, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onfetchUpdateCommission(baId, commissionId, data));
};
export const onfetchUpdateCommission = createAction(
    'FETCH_UPDATE_COMMISSION',
    (baId, commissionId, data) => Api.updateCommission(baId, commissionId, data),
    () => ({
        apiCall: true,
        onSuccess: fetchUpdateCommissionSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onUpdateCommissionsCountryFilter = createAction('UPDATE_COMMISSIONS_COUNTRY_FILTER');
export const updateCommissionsCountryFilter  = (countryFilter) => (dispatch, getState) => {
    let BAFilter = getCommissionsBAFilter(getState());
    let filters = {
        baId: BAFilter,
        countries: countryFilter || getCountriesData(getState()),
    }
    dispatch(onFetchGetCommissions(0, filters));
    dispatch(onUpdateCommissionsCountryFilter(countryFilter));
}

export const onUpdateCommissionsBAFilter = createAction('UPDATE_COMMISSIONS_BA_FILTER');
export const updateCommissionsBAFilter  = (BAFilter) => (dispatch, getState) => {
    let countryFilter = getCommissionsCountryFilter(getState());
    let filters = {
        baId: BAFilter,
        countries: countryFilter || getCountriesData(getState()),
    }
    dispatch(onFetchGetCommissions(0, filters));
    dispatch(onUpdateCommissionsBAFilter(BAFilter));
}
//- State
const initialState = {
    data: null,
    countryFilter: null,
    BAFilter: null,
    fetching: false,
    error: null,
    commissionToRemoveId: null,
    currentPage: null,
    totalPages: null,
    BAsList: null,
    BAsFetching: false,
    currentCommissionData: null,
    currentCommissionFetching: false,
};

//- Reducers
export default handleActions({
    FETCH_GET_COMMISSIONS: (state) => {
        return {...state, data: null, currentPage: null, totalPages: null, error: null, fetching: true};
    },
    FETCH_GET_COMMISSIONS_FAILED: (state, action) => {
        return {...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false};
    },
    FETCH_GET_COMMISSIONS_SUCCESS: (state, action) => {
        return {
            ...state,
            data: action.payload.content,
            currentPage: action.payload.number,
            totalPages: action.payload.totalPages,
            error: null,
            fetching: false
        };
    },
    COMMISSION_TO_REMOVE_SET: (state, action) => {
        return {...state, commissionToRemoveId: action.payload};
    },
    FETCH_GET_BA_S_LIST: (state) => {
        return {...state, BAsList: null, error: null, BAsFetching: true};
    },
    FETCH_GET_BA_S_LIST_FAILED: (state, action) => {
        return {...state, BAsList: null, error: action.payload, BAsFetching: false};
    },
    FETCH_GET_BA_S_LIST_SUCCESS: (state, action) => {
        return {...state, BAsList: action.payload, error: null, BAsFetching: false};
    },
    FETCH_GET_COMMISSION_DATA: (state) => {
        return {...state, currentCommissionData: null, error: null, currentCommissionFetching: true};
    },
    FETCH_GET_COMMISSION_DATA_FAILED: (state, action) => {
        return {...state, currentCommissionData: null, error: action.payload, currentCommissionFetching: false};
    },
    FETCH_GET_COMMISSION_DATA_SUCCESS: (state, action) => {
        return {...state, currentCommissionData: action.payload, error: null, currentCommissionFetching: false};
    },
    UPDATE_COMMISSIONS_COUNTRY_FILTER: (state, action) => {
        return { ...state, countryFilter: action.payload };
    },
    UPDATE_COMMISSIONS_BA_FILTER: (state, action) => {
        return { ...state, BAFilter: action.payload };
    },
}, initialState);

//- Selectors
export const getCommissions = state => state.commissions;

export const loadingCommissions = state => getCommissions(state).fetching;

export const getCurrentPageForCommissions = state => getCommissions(state).currentPage;

export const getTotalPagesForCommissions = state => getCommissions(state).totalPages;

export const getCommissionsData = state => {
    if (_.isNil(getCommissions(state).data)) {
        return null;
    }

    return _.map(getCommissions(state).data, data => ({
            id: data.id,
            baId: data.baId,
            name: data.firstName + " " + data.lastName,
            continent: data.continent,
            countries: data.countryCodes,
            commission: data.commissionPercent,
            dateFrom: moment(data.dateFrom).format('L'),
            dateTo: moment(data.dateTo).format('L')
        })
    );
};

export const getCommissionToRemoveId = state => getCommissions(state).commissionToRemoveId;

export const getCommissionToRemove = state => {
    let id = getCommissionToRemoveId(state);
    return _.find(getCommissionsData(state), data => data.id === id );
};

export const loadingBAsList = state => getCommissions(state).BAsFetching;

export const getBAsList = state => getCommissions(state).BAsList;

export const getCurrentCommissionData = state => getCommissions(state).currentCommissionData;

export const getCurrentCommissionDataFormatted = state => {
    let data = getCurrentCommissionData(state);
    if (!data) {
        return null;
    }

    return {
        id: data.id,
        baId: data.businessAmbassadorId,
        continent: data.continent,
        countries: data.countryCodes,
        commission: data.commissionPercent,
        dateFrom: moment(data.dateFrom),
        dateTo: moment(data.dateTo)
    };
};

export const loadingCurrentCommission = state => getCommissions(state).currentCommissionFetching;

export const getCommissionsCountryFilter = state => getCommissions(state).countryFilter;

export const getCommissionsBAFilter = state => getCommissions(state).BAFilter;


// WEBPACK FOOTER //
// ./src/reducers/commission/commissions.js